import type { HowRelayWorksReference } from "./types";

export const pagesReference: HowRelayWorksReference = {
  slug: "pages",
  name: "Pages",
  oneLiner: "What's in the left menu.",
  sections: [
    {
      title: "The left menu, top to bottom",
      items: [
        "Control Center: the place that needs you. It opens on Actions, and a red dot means something's waiting. Tabs: Sprint Planning, Sprint Board, Actions, Sprint History, Recovery, Search.",
        "All Activity: the full Log, everything posted.",
        "Decisions: what's already been decided.",
        "Create-A-Project: each project's background.",
        "Build-A-Spec: a floating panel for drafting a checked spec.",
        "Test-A-Feature: step-by-step test cases and runs.",
        "Backup-My-Git: back up the git repos on your own computer to a folder you choose, and restore them. Relay keeps no copies.",
        "Backlog: saved specs waiting to be built. Its Backlog Cleanup tab flags items that look built, replaced, duplicated or old, for you to decide.",
        "⚙ Workspace: settings (Account, Charter, Governance, Project Management).",
        "Team: people, AI partners and invites.",
        "Notes & Tasks: a quick floating notepad.",
        "How Relay Works: this page.",
        "Relay Admin: shown only to the person who set up the workspace; edits the Charter.",
      ],
    },
  ],
};
